import { MyPlaylists } from '@statsbomb/video-client-js';
import React from 'react';

export function MyPlaylistsBasic() {
  return <MyPlaylists enableCreateCutup enableSelectAll />;
}
MyPlaylistsBasic.propTypes = {};

export default { MyPlaylistsBasic };
